<template>
  <div class="product-seller">
    <div class="product-seller__info">
      <img :src="product.seller.user.photo_small" :alt="product.seller.user.name" class="product-seller__image" />

      <div class="product-seller__name-and-reviews">
        <component
          :is="loggedIn ? 'router-link' : 'p'"
          :to="{
            name: 'provider',
            params: { userId: product.seller.id },
          }"
          class="product-seller__name"
        >
          {{ product.seller.user.name }}
        </component>

        <Rating :rate="product.seller.rating" :size="8" class="product-seller__rating" />

        <!-- <span class="product-seller__reviews">
          {{ $t('{0} reviews', [0]) }}
        </span> -->
      </div>
    </div>

    <div class="product-seller__org">
      <p>
        {{ $t('Registered: {0}', [localeDate(product.seller.user.created_at)]) }}
      </p>
      <p>
        <span>{{ product.seller.organization?.short_title }}</span>
        <CheckCircle v-if="product.seller.organization?.verified" :title="$t('Organization verified')" />
      </p>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/common/Rating.vue'
import localeDate from '@/helpers/filters/localeDate'
import { CheckCircle } from 'lucide-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductPageSeller',
  components: {
    Rating,
    CheckCircle,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
  },
  methods: {
    localeDate,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.product-seller {
  background-color: $GreenM;
  border-radius: 4px;
  padding: 12px;
  color: $White;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  row-gap: 10px;
  column-gap: 12px;
  flex-wrap: wrap;

  @include media-breakpoint-up(xl) {
    padding: 20px 30px;
    border-radius: 8px;
    gap: 16px;
  }

  &__name-and-reviews {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-width: 100%;
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 8px;

    @include media-breakpoint-up(xl) {
      gap: 16px;
      margin-right: 40px;
    }
  }

  &__image {
    width: 32px;
    height: 32px;
    border-radius: 50%;

    @include media-breakpoint-up(xl) {
      width: 56px;
      height: 56px;
    }
  }

  &__name {
    font-weight: 500;
    text-decoration: underline;
    color: inherit;
  }

  &__rating {
    &::v-deep .icon-star-rating {
      @include media-breakpoint-up(xl) {
        font-size: 12px !important;
      }
    }
  }

  &__reviews {
    font-size: 12px;
    line-height: 1.1;

    @include media-breakpoint-up(xl) {
      font-size: 14px;
      line-height: 16px;
    }
  }

  &__org {
    font-size: 12px;
    line-height: 14px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-weight: 500;
    opacity: 0.7;

    @include media-breakpoint-up(xl) {
      gap: 6px;
    }

    svg {
      margin-left: 3px;
      width: 12px;
      height: 12px;
    }
  }
}
</style>
